module.exports = __webpack_public_path__ + "static/hero-image2-3de6ee1c4016155ff8b6b4aea5b69585.jpg";